export const TRADING_PAIRS = {
  "Forex Majors": [
    "EUR/USD",
    "USD/JPY",
    "GBP/USD",
    "USD/CHF",
    "AUD/USD",
    "USD/CAD",
    "NZD/USD",
  ],
  "Forex Crosses": [
    "EUR/GBP",
    "EUR/JPY",
    "GBP/JPY",
    "EUR/AUD",
    "GBP/CHF",
    "AUD/JPY",
    "CAD/JPY",
    "EUR/CHF",
    "NZD/JPY",
    "AUD/NZD",
  ],
  "Metals (CFD)": ["XAU/USD", "XAG/USD", "XPT/USD", "XPD/USD"],
  "Indices (CFD)": [
    "US30",
    "SPX500",
    "NAS100",
    "GER40",
    "UK100",
    "JP225",
    "AUS200",
  ],
  "Crypto": ["BTC/USD", "ETH/USD", "SOL/USD", "XRP/USD"],
  "Energy (CFD)": ["WTI/USD", "BRENT/USD", "NATGAS/USD"],
};

export const ALL_PAIRS = Object.values(TRADING_PAIRS).flat();
